import React, { Component } from 'react';
import {
  Input,
  InputNumber,
  Form,
} from 'antd';

import { EditableContext } from './MetadataTable';
import i18n from '../../config/i18n';

class EditableCell extends Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber />;
    }
    return <Input />;
  };

  renderCell = ({ getFieldDecorator }) => {
    // not only destruct , but we remove non-standard/invalid DOM properties from prop
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      required,
      ...restProps
    } = this.props;
    const RequiredMessage = () => i18n.t('fieldRequired');

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required,
                  message: <RequiredMessage />,
                },
              ],
              initialValue: record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
  }
}

export default EditableCell;



// WEBPACK FOOTER //
// ./src/components/metadata/EditableTableCell.js